<template>
  <section class="suporte-equipamentos">
    <!-- Banner Técnico -->
    <div class="banner-equipamentos">
      <img
        src="/img/suporte/banner-equipamento.webp"
        alt="Banner Suporte de Equipamentos Click Sorvetes"
        class="banner-img"
      />
      <div class="linha-rosa"></div>
    </div>

    <!-- Conteúdo -->
    <div class="conteudo-equipamentos">
      <header class="header-equipamentos">
        <h1>Suporte de equipamentos</h1>
        <p class="descricao">
          Tutoriais, manuais e instruções técnicas para operação, limpeza e manutenção dos
          equipamentos Click-One e Click-Zero.
        </p>
      </header>

      <div class="cards-container">
        <SuporteComponent
          v-for="item in listaItens"
          :key="item.id"
          v-bind="item"
        />
      </div>
    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from "vue";
import SuporteComponent from "@/components/SuporteComponent.vue";
import { getJson } from "@/utils";

const listaItens = ref([]);

onMounted(async () => {
  try {
    listaItens.value = await getJson("/database/suporte/Equipamentos.json");
  } catch (err) {
    console.error("Erro ao carregar o arquivo JSON de equipamentos:", err);
  }
});
</script>

<style scoped>
/* ==============================
   BANNER FULL WIDTH
================================*/
.banner-equipamentos {
  position: relative;
  width: 100vw;
  left: 50%;
  right: 50%;
  margin-left: -50vw;
  margin-right: -50vw;
  overflow: hidden;
  background: var(--branco);
}

.banner-img {
  width: 100%;
  height: auto; /* imagem controla a altura */
  object-fit: contain; /* mostra a imagem inteira */
  object-position: center;
  display: block;
}

/* Linha rosa rente à imagem */
.linha-rosa {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 4px;
  background-color: var(--rosa-principal);
}

/* ==============================
   CONTEÚDO PRINCIPAL
================================*/
.suporte-equipamentos {
  background: var(--cinza-claro);
  color: var(--cinza-escuro);
}

.conteudo-equipamentos {
  max-width: 1200px;
  margin: 0 auto;
  padding: 4rem 1rem 5rem;
  text-align: center;
}

.header-equipamentos h1 {
  font-size: 2.2rem;
  font-weight: 700;
  text-transform: uppercase;
  color: var(--rosa-principal);
  letter-spacing: -0.5px;
  margin-bottom: 1rem;
}

.descricao {
  max-width: 800px;
  margin: 0 auto;
  color: #333;
  font-size: 1.05rem;
  line-height: 1.6;
}

/* ==============================
   GRID DE CARDS
================================*/
.cards-container {
  display: grid;
  gap: 2rem;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  padding: 0 1rem;
}
</style>
